<template>
    <router-link class="menu-item" :to="to">
        <typo name="menu-12-bold">
            <slot></slot>
        </typo>
    </router-link>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
    props: ["to"],
});
</script>

<style lang="sass" scoped>
.menu-item
    height: 50px
    display: flex
    align-items: center
    padding-left: 20px
    padding-right: 20px
    text-align: center
    color: $color-secondary
    transition: background .15s ease, color .15s ease
    &:hover
        background: $color-secondary
        color: white
    +r(480)
        padding-left: 10px
        padding-right: 10px

    &.router-link-active
        background: $color-secondary
        color: white
</style>
